import { useReducer } from "react";
import Navbar from "./components/navbar/navbar";
import MultiStepper from "./multistepper/multistepper";
import { ContainerStyled } from "./user-book-appointments.styles";
import {
  initialState,
  reducer,
  UserAppointmentContext,
} from "./context/user-appointment-context";

const UserBookAppointments: React.FC = () => {
  const [state, userDispatcher] = useReducer(reducer, initialState);
  return (
    <UserAppointmentContext.Provider value={{ state, userDispatcher }}>
      <ContainerStyled className="container-wrapper">
        <Navbar />
        <MultiStepper />
      </ContainerStyled>
    </UserAppointmentContext.Provider>
  );
};

export default UserBookAppointments;
